module.exports = __webpack_public_path__ + "img/pic6.1671a06d.png";